import { ApiError } from '@/api/errors';
import { env } from '@/env/env';
import axios, { isAxiosError } from 'axios';

export const getHeaders = () => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json;charset=UTF-8'
  };

  return { headers };
};

export const api = axios.create({
  baseURL: env.VITE_MOCK_MODE ? '/' : (env.VITE_SHIPLEX_BASE_URL ?? '/')
});

let clerkGetToken: (() => Promise<string | null>) | null = null;

export const setClerkTokenGetter = (getter: () => Promise<string | null>) => {
  clerkGetToken = getter;
};

api.interceptors.request.use(async (config) => {
  if (clerkGetToken) {
    try {
      const token = await clerkGetToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting Clerk token:', error);
    }
  }

  return config;
});

const getErrorMessage = (data: unknown): string | undefined => {
  if (typeof data !== 'object' || data === null || !('ErrorMessage' in data) || typeof data.ErrorMessage !== 'string') {
    return undefined;
  }
  return data.ErrorMessage;
};

const isErrorEnvelope = (data: unknown): boolean =>
  typeof data === 'object' && data !== null && 'Error' in data && data.Error === true;

api.interceptors.response.use(
  (response) => {
    if (isErrorEnvelope(response.data)) {
      return Promise.reject(
        new ApiError(getErrorMessage(response.data) ?? 'Unknown error', response.status, response.data)
      );
    }
    return response;
  },
  (error: unknown) => {
    if (isAxiosError(error)) {
      const response = error.response;
      const message = getErrorMessage(response?.data) ?? error.message;
      const status = response?.status ?? error.status;
      return Promise.reject(new ApiError(message, status, response?.data));
    }
    return Promise.reject(new ApiError('Unknown error'));
  }
);

export const CACHE_TIME = {
  STALE: 5 * 60 * 1000,
  GC: 10 * 60 * 1000
} as const;
